import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class IssueFindSnPhoneAuthCodeUsecase {
  constructor(private readonly userPasswordRepo: UserPasswordRepository) {}

  async execute(loginId: string, phone: string): Promise<SATResult<string, SATError>> {
    return this.userPasswordRepo.issueFindSnPhoneAuthCode({
      loginId: loginId.trim().toLowerCase(),
      phone: phone.trim(),
    });
  }
}
